<template>
    <div id="zpert">
        <div class="title">恭喜您已注册成功获得90天免费使用权</div>
        <div class="sub-title-wrap">
            <span class="sub-title">广联达BIM工序动画制作软件教学视频送给你</span>
        </div>
        <div class="sub-title-wrap">
            <span class="sub-title">学习地址：https://www.bilibili.com/video/BV15f4y1g7Z3</span>
        </div>
        <div class="sub-title-wrap">
            <span class="sub-title">（复制链接至电脑浏览器观看）</span>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
            }
        }
    }
</script>

<style scoped lang="scss">
#zpert {
    .title {
        margin-top: 20px;
    }
    .sub-title-wrap {
        margin-top: 20px;
    }
    .bold-title {
        margin-top: 20px;
    }
}
</style>